<template>
  <modal name="report" @closed="closeModal" height="auto">
    <card>
      <label>{{ "rep_write" | setText("Напишите жалобу") }}</label>
      <textarea class="form-control" v-model="description"></textarea>
      <br />
      <p-button
        class="w-100 mb-3"
        type="warning"
        round
        @click.native.prevent="report"
      >
        {{ "send" | setText("Отправить") }}
      </p-button>
      <p-button
        class="w-100"
        type="error"
        round
        @click.native.prevent="$modal.hide('report')"
      >
        {{ "canel" | setText("Отмена") }}
      </p-button>

      <report-list :client_id="client_id" :discipline_id="discipline_id" />
    </card>
  </modal>
</template>

<script>
import { setReport } from "@/_api/apiPupil";
import ReportList from "./ReportList.vue";
export default {
  components: { ReportList },
  props: {
    client_id: {
      default: null,
    },
    discipline_id: {
      default: null,
    },
  },
  methods: {
    setReport: setReport,
    report() {
      this.setReport(this.client_id, this.discipline_id, this.description);
    },
    closeModal() {
      this.description = "";
    },
  },
  data() {
    return {
      description: "",
    };
  },
};
</script>